/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FavoriteSortBy {
    LAST_FAVORITED = 'last_favorited',
    RECENTLY_ACTIVE = 'recently_active',
}
